import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

import BaseTable, { 
    TableStore,
    connect,
    useStore, 
    useResize, 
    useIndex, 
    useCheckbox, 
    useSort, 
    useExpandRow,
    useTreeTable,
    useFilter,
    usePagination,
    useErrorTips,
    useRowClick,
    useLocation,
    useContextMenu,
    useCellSelect,
    useHotKey,
    useDOM,
    useSimpleTable,
    useCache,
    useStyle,
} from "@platform/table-core";
import { ViewModel } from '@platform/api';
import { getAutoWrap } from '../../libs/useContextMenu';
import { getRowHeight, setAutoWrap } from '../utils';
import { getMultiLang, getGlobalStorage } from '@platform/api';

let hookExtensions = [
    connect,
    useHotKey, 
    useStore, 
    useResize,
    useIndex,
    useCheckbox,
    useExpandRow,
    useRowClick,
    useTreeTable,
    useSort,
    useCellSelect,
    useDOM,
    useSimpleTable,
    usePagination,
    useCache,
    useFilter,
    useLocation,
    useContextMenu,
    useStyle,
    // useCopy,
    useErrorTips,
];

const ComposedTable = hookExtensions.reduceRight((Table, HOC) => HOC(Table), BaseTable);

class SimpleTable extends Component {
    cached = false;

    componentDidMount() {
        this.props.store.setRef(this);
        this.useCache();

        let { store } = this.props;

        getMultiLang({
            moduleId: "page_table",
            callback: json => {
                store.setLocale(json);
            }, 
        });

        this.useCache();
    }
    
    render () {
        let {
                showCheck,
                showIndex,
                pkname,
                high_selectable,
                handlePageInfoChange,
                extendRightMenu,
                dataSource,
                crossPageSelect,
                onRowClick, 
                onRowDoubleClick, 
                selectedChange, 
                onSelected, 
                onSelectedAll, 
                onBatchSelected, 
                tableModelConfirm, 
                rowClassName, 
                adaptionHeight = true,
                height,
                cancelCustomRightMenu = false,
                showWidthAndHeightConfig = true,
                hideRightMenu = false,
                extendRightMenuPlacement,
                alloweFilter: enableFilter = true,
                handleFilterCallBack,
                handleResetCallBack,
                sort,
                hiddenLeftItem,
                noColSetClass,
                colSetCallback,
                showTotal,
                setCellClass,
                showPagination,
                disableClickRowToSelect, //只有simpletable有这个参数
                fieldid,
                tableCustomerArea,
                id,
                store,
                pageScope,
                allowTotalRows,
                noTotalRows,
                noTotalCol,
                onTableCellClick,
                addBlankCol,
                setSelectedNum,
                columnWidthConfig = true,
                fixFooter,
                scrollContainer,
                // addAffixScroll: fixFooter,
            } = this.props,
            config = store.getConfig(),
            useVirtual = true;
    
        if(hideRightMenu){
            cancelCustomRightMenu = true;
        }

        //初始化
        if(config.hasOwnProperty('multipleRowCell')){
            setAutoWrap(store, id, config.multipleRowCell);
        }

        let ncc_automated = getGlobalStorage('localStorage', '_ncc_automated_');
        if (ncc_automated == '1') {
            // 自动化测试开关打开
            useVirtual = false;
        }

        return <ComposedTable
            key={id} 
            id={id} 
            store={store}
            pageScope={pageScope}
            fixFooter={fixFooter}
            scrollContainer={scrollContainer}
            autoRowHeight={getAutoWrap(store, id)}
            bodyStyle={{ 
                height: height || 300,
                minHeight: 60,
            }}
            addBlankCol={addBlankCol}
            flex={adaptionHeight}
            rowHeight={getRowHeight()}
            className="simple-table"
            defaultRenderStatus='browse'
            alwaysBrowse // switch_browse不显示组件，显示文字
            renderItems={pageScope.state.renderItem?.table?.[id] || {}}
            rowKey={row => row.key}
            allowTotalRows={allowTotalRows}
            noTotalRows={noTotalRows}
            noTotalCol={noTotalCol}
            virtualConfig={{ x: useVirtual }}
            simpleTableConfig={{ 
                enable: true,
                tableModelConfirm,
            }}
            indexConfig={{ enable: showIndex }}
            checkboxConfig={{ 
                enable: showCheck,
                more: crossPageSelect && pkname,
                setSelectedNum,
                onCheck: (rowKey, { isChecked, checkedKeys, lastCheckedKeys }) => {
                    if (rowKey) {
                        let row = store.getRowData(rowKey);
                        if (isChecked ) {
                            store.setClickedRow(rowKey);
                        } else {
                            store.setClickedRow('');
                        }
                        
                        onSelected?.call(
                            pageScope,
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            store.getInstance()._formatOutputRow(row),
                            row.dataIndex,
                            isChecked,
                        );
                    } else {
                        let visibleRowKeys = store.getVisibleRowKeys();
                        onSelectedAll?.call(
                            pageScope,
                            { ...pageScope.props, ...pageScope.output },
                            id,
                            !!checkedKeys.size, // checkedAll
                            visibleRowKeys.length,
                        );
                    }
                    selectedChange?.call(
                        pageScope,
                        { ...pageScope.props, ...pageScope.output },
                        id,
                        checkedKeys.size,
                        lastCheckedKeys.size,
                    );
                },
            }}
            cellSelectConfig={{ 
                enable: high_selectable?.enable ?? true,
                batchSelectEnable: false,
                onSelect: (selectedCell, { startCell, endCell, batchSelect }) => {
                    console.log('框选', selectedCell);

                    if (!startCell || !endCell || batchSelect) {
                        return;
                    }

                    if (onBatchSelected) {
                        /**
                         * 传了这个参数，才勾选前面的行。以前的逻辑是这样的
                         * 如果选中的是单行，走onRowClick逻辑
                         * 否则这里设置选中
                         */
                        // endCell?.row?.key && startCell.row.key !== endCell.row.key && store.setCheckedKeys(new Set([...selectedCell.keys()]));
                        // 单行onRowClick走不到这里，cellSelect那里已经阻断了
                        store.setCheckedKeys(new Set([...selectedCell.keys()]));
                        onBatchSelected(
                            {
                                ...pageScope.props,
                                ...pageScope.output,
                            }, 
                            id, 
                            [...selectedCell].map(([rowKey]) => store.getRowData(rowKey)),
                        );
                    }
                },
            }}
            rowProps={row => ({
                disableClickRowToSelect,
                onClick: event => {
                    return onRowClick?.call(
                        pageScope,
                        { ...pageScope.props, ...pageScope.output },
                        id,
                        store.getInstance()._formatOutputRow(row),
                        row.dataIndex,
                        event,
                    );
                },
                onDoubleClick: onRowDoubleClick && (event => {
                    return onRowDoubleClick?.call(
                        pageScope,
                        store.getInstance()._formatOutputRow(row),
                        row.dataIndex,
                        { ...pageScope.props, ...pageScope.output },
                        event,
                    );
                }),
                className: typeof rowClassName === 'function' ? 
                    rowClassName(store.getInstance()._formatOutputRow(row), row.dataIndex) :
                    rowClassName,
            })}
            paginationConfig={{ 
                enable: showPagination ?? store.getMeta()?.[id]?.pagination,
                defaultPageSize: config.defaultPageSize,
                maxPageSize: config.maxPageSize,
                onChange: ({ pageIndex, pageSize }) => {
                    let { allpks } = store.getAllRowsInfo();

                    if (!allpks?.length) return;

                    handlePageInfoChange?.(
                        { ...pageScope.props, ...pageScope.output }, 
                        config, 
                        allpks.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize), 
                        allpks.length,
                    );
                },
            }}
            totalConfig={{ enable: showTotal }}
            filterConfig={{ 
                enable: enableFilter,
                title: store.getMeta()?.[id]?.name || '',
                onFilter: handleFilterCallBack,
                onReset: handleResetCallBack,
            }}
            sortConfig={{ 
                enable: true,
                onSort: orderMap => {
                    let sortInfo = [...orderMap].map(([colKey, order], index) => {
                        return {
                            order: order === 1 ? "ascend" : "descend",
                            field: colKey,
                            orderNum: index,
                        };
                    });
                sort?.sortFun?.(sortInfo, store.getVisibleRows());
                },
            }}
            locationConfig={{ enable: true }}
            dataSource={dataSource}
            pkname={pkname}
            crossPageSelect={crossPageSelect}
            contextMenuConfig={{ 
                enable: !hideRightMenu && (high_selectable?.enable ?? true) && (high_selectable?.selectCell ?? true),
                extendRightMenu,
                extendRightMenuPlacement, // 原代码的simpleTable没有这个值
                showRowMenu: false,
                cancelCustomRightMenu,
                showWidthAndHeightConfig,
                hiddenLeftItem,
                columnWidthConfig,
                disableArea: (rowKey, colKey) => {
                    if(!noColSetClass) return false;
                    let cellClass = store.getCellProps(rowKey, colKey, 'className');
                    return cellClass?.includes(noColSetClass);
                },
                onColSetting: () => {
                colSetCallback?.();
                },
                onClick: () => {
                    pageScope.forceUpdate();
                },
            }}
            cellProps={(rowInfo, colInfo) => {
                let props = {};
                if (typeof onTableCellClick === 'function') {
                    props.onClick = e => {
                        onTableCellClick(rowInfo.row, rowInfo.rowIndex, colInfo.col.key, colInfo.col, e);
                    }; 
                }
                if (typeof setCellClass === 'function') {
                    props.className = setCellClass(rowInfo.rowIndex, store.getInstance()._formatOutputRow(rowInfo.row), colInfo.col.key);
                }
                return props;
            }}
            fieldid={fieldid}
            footer={tableCustomerArea} 
        />;
    }

    componentDidUpdate() {
        this.useCache();
    }

    componentWillUnmount() {
        let { dataSource, store, pkname } = this.props;
        
        if (dataSource) {
            let pageInfo = store.getPaginationInfo(),
                rows = store.getRows(),
                { allpks } = store.getAllRowsInfo(),
                filterInfo = store.getFilterInfo(),
                checkedInfo = store.getCheckedInfo(),
                sortInfo = store.getSortInfo(),
                lastClickedRow = store.getClickedRow(),
                visibleRows = store.getVisibleRows(),
                currentpks = visibleRows.map(row => row.values[pkname]?.value).filter(e => e),
                { pageIndex, pageSize } = pageInfo;
    
            allpks = allpks ? [...allpks] : [];

            let cacheAllPks = [...allpks];
            allpks.splice(Number(pageIndex) * Number(pageSize), pageSize, ...currentpks);

            let data = {
                simpleTable:{
                    rows: rows,
                    currentpks, // 当页的pk
                    allpks,
                    cacheAllPks,
                    pageInfo,
                    scrollTop: findDOMNode(this).querySelector('.vertical-scroll-bar').scrollTop,
                    checkedInfo,
                    filterInfo,
                    sortInfo,
                    pkname,
                    lastClickedRow,
                },
            };
        
            ViewModel.setData(dataSource, data);
        }

        this.props.store.removeRef(this);
    }

    useCache = () => {
        let { dataSource, store } = this.props,
            columns = store.getColumns(),
            { componentInitFinished } = store.getConfig() || {};

        if (dataSource && !this.cached && columns.length) {
            this.cached = true;

            let cache = ViewModel.getData(dataSource)?.simpleTable;
            
            if (!cache) return;

            if (cache.pageInfo) {
                store.setPaginationInfo(cache.pageInfo);
            }

            if (cache.rows) {
                store.setRows({ rows: cache.rows });
            }

            if (cache.cacheAllPks) {
                store.setAllRowsInfo({ allpks: cache.cacheAllPks });
            }

            if (cache.scrollTop && cache.rows.length) {
                this.scroll(cache.scrollTop);
            }

            if (cache.lastClickedRow) {
                store.setClickedRow(cache.lastClickedRow);
            }

            // if (cache.currentpks) {

            // }

            if(cache.checkedInfo) {
                store.setCheckedInfo(cache.checkedInfo);
            }

            if(cache.filterInfo){
                store.setFilterInfo(cache.filterInfo);
            }

            if(cache.sortInfo){
                store.setSortInfo(cache.sortInfo);
            }

            componentInitFinished?.();
        }
    }

    scroll = scrollTop => {
        requestAnimationFrame(() => {
            if (findDOMNode(this).querySelectorAll('.table-next-body tr:not(.empty-table)').length) {
                findDOMNode(this).querySelector('.vertical-scroll-bar').scrollTop = scrollTop;
            } else {
                this.scroll(scrollTop);
            }
        });
    }
}

SimpleTable.displayName = 'SimpleTable';
SimpleTable.useSimpleTable = function () {
    let store = new TableStore(hookExtensions);
    return store.getAllHooks();
};

export default SimpleTable;